import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessagesService } from '@core/_services/messages.service';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { verifyParamsRequest, deleteList, findItem } from '@core/_utils/tools.utils';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'treesearchrequest',
    templateUrl: './treesearchrequest.component.html',
    styleUrls: ['./treesearchrequest.component.scss'],
    providers: [AutofocusDirective],
})
export class TreeSearchRequestComponent implements OnInit {
    @Input() public visible = false;
    @Input() public requests = [];
    @Input() public searchPath = '';

    @Output()
    public onSelectRequest: EventEmitter<any> = new EventEmitter();
    @Output()
    public onCloseRequest: EventEmitter<any> = new EventEmitter();

    public errorMessage = '';
    public errorLoaderDialog = false;
    public itemConfirm: ItemConfirmComponent;

    public currentId = 0;
    public currentLabel = '';
    public labelRequest = '';
    public displayUpdate = false;

    public listColumnsRequest = [];

    constructor(
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private translate: TranslateService,
        private api: ApiV6Service
    ) {
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumnsRequest = [
            { header: this.translate.instant('Name'), field: 'label' },
            { header: this.translate.instant('File_path'), field: 'searchPath' },
        ];
    }

    public close() {
        this.onCloseRequest.emit(false);
        this.visible = false;
    }

    public showDetails($event) {
        let wRequestData = this.setDataRequest($event.data);
        this.currentId = $event.data.id;
        this.currentLabel = $event.data.label;
        this.labelRequest = $event.data.label;
        this.onSelectRequest.emit(wRequestData);
        this.close();
    }

    public unSelect() {
        this.currentId = 0;
        this.currentLabel = '';
    }

    public addRequest() {
        if (this.verifyPath() === false) {
            return;
        }
        if (this.currentId !== 0) {
            this.labelRequest = this.currentLabel;
        } else {
            this.labelRequest = '';
        }
        this.displayUpdate = true;
    }

    public updateRequest($event, aData) {
        $event.stopPropagation();
        this.currentId = aData.id;
        this.currentLabel = aData.label;
        this.labelRequest = aData.label;
        this.displayUpdate = true;
    }

    public deleteRequest($event, aData) {
        $event.stopPropagation();
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_Del', {label: aData.label}),
            () => {
                this.delete(aData);
            }
        );
    }

    public async delete(aData) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deletetreesearch', aData.id));
            this.currentId = 0;
            this.currentLabel = '';
            this.requests = [...deleteList(this.requests, wRes.data)];
            this._messageService.addSuccess(this.translate.instant('Update_OK'));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
        this.closeDia(null);
    }

    public async validRequest() {
        let wRes: any;
        if (
            verifyParamsRequest(
                this.labelRequest,
                this.currentLabel,
                this.currentId,
                this.requests,
                this._messageService,
                this.translate
            ) === false
        ) {
            return;
        }
        if (this.labelRequest !== this.currentLabel) {
            this.currentId = 0;
        }
        // id de la requête forcé à 0 : création
        const wdata = {            
            entete: this.prepareRequestData()
        }
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('updatetreesearch', wdata));
            this.requests = [...this.updateListRequest(this.requests, wRes)];
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
        this.displayUpdate = false;
    }

    private updateListRequest(aRequest, aData) {
        let wIndex = -1;
        wIndex = findItem(aRequest, aData.id, 'id');
        aData.searchPath = aData.searchPath.replace(/\//g, '\\');
        if (wIndex !== -1) {
            aRequest[wIndex] = aData;
        } else {
            aRequest.push(aData);
        }
        return aRequest;
    }

    private prepareRequestData() {
        const requestData = {
            id: this.currentId,
            description: null,
            idResult: null,
            label: this.labelRequest,
            visibility: null,
            searchPath: this.searchPath,
        };
        return requestData;
    }

    public closeDia(event) {
        this.displayUpdate = false;
    }

    private verifyPath() {
        if (this.searchPath.trim() === '') {
            this._messageService.addErrorNoStick(this.translate.instant('Path_Sel'));
            return false;
        }
        return true;
    }

    private setDataRequest(aData) {
        const requestData = {
            searchPath: '',
        };
        requestData.searchPath = aData.searchPath;
        return requestData;
    }

    setFilteredList(event) {}
}
